<template>
    <el-dialog title="新增方案" :visible.sync="programeAddDialog" width="300px" :close-on-click-modal="false"
        :before-close="programmeDialogCancel" :open="open">
        <el-input v-model="name" placeholder="请输入方案名称"></el-input>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="programmeDialogConfirm">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>
import * as copyUtils from "../../minixs/CopyUtils"

export default {
    name: "ProgrameAddDialog",
    data() {
        return {
            programeAddDialog: false,
            name: "",
            nameList: []
        }
    },
    methods: {
        init() {
            name = "";
        },
        open(nameList) {
            // 配置所有的缓存
            this.init();
            this.nameList = nameList;
            this.programeAddDialog = true;
        },
        async programmeDialogConfirm() {
            if (this.validname()) {
                this.$emit("confirm", this.name);
                this.programeAddDialog = false;
                this.init();
            }
        },
        async programmeDialogCancel() {
            this.programeAddDialog = false;
            this.init();
        },
        async validname() {
            if (this.nameList.includes(this.name)) {
                this.$alert("方案名称已存在请更换方案名称");
                return false;
            } else if (this.name == null || this.name == "") {
                this.$alert("方案名称不能为空");
                return false
            }
            return true;
        },
    },
    mounted() {
        this.init();
    }

}
</script>


<style lang="less" scoped>
.recipeLine {
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid;
    border-radius: 10px;
    display: flex;

    .recipeLineTitle {
        width: 100px;
        padding-right: 10px;
        font-size: 20px;
        font-weight: bold;
        color: rgb(211, 36, 36)
    }
}
</style>